import React, { Component } from 'react';
import { Card, CardBody, CardText, CardImg, CardImgOverlay, Row, Col } from 'reactstrap';
import ExploreBoards from '../images/ExploreBoards.jpg';
import Applications from '../images/Applications.jpg'
import Watch from '../images/meeting.jpeg';
import YoutubeEmbed from './YouTubeEmbed/YoutubeEmbed';

export class Home extends Component {
    static displayName = Home.name;

    exploreBoards = () => {
        this.props.history.push('explore');
    }

    applyBoards = () => {
        this.props.history.push('signin');
    }

    watchMeetings = () => {
        window.open('https://www.youtube.com/playlist?list=PLMtGiLExj1Rm-4CTqJe1RqA2WrwhY1OZH');
    }

  render () {
        return (        
            <div
                className="rounded px-3 px-sm-4 py-3 py-sm-5"
                style={{ backgroundColor: "#e9ecef"}}
            >
                <Row>
                    <Col sm={6}>
                        <p className='lead'>
                            <em>
                                St. Louis County’s boards and commissions offer residents an opportunity to play a direct role
                                in making our community an exceptional place to live, work and raise a family.
                                These bodies serve as subsets of government, created to advise County leaders on a broad spectrum of issues,
                                including transportation, the arts, public safety, planning, health, housing, economic development,
                                parks and recreation, construction codes, and other matters that directly impact our quality of life.
                            </em>
                        </p>
                    </Col>
                    <Col sm={6}>
                        <YoutubeEmbed embedId='-TXEkUOJ5ec' />
                    </Col>
                </Row>
                <Row className='py-5'>
                    <Col sm={12}>
                        <blockquote className="blockquote text-center">
                            <p className="mb-0">
                                “As County Executive, I am committed to ensuring that our boards and commissions are composed of
                                highly qualified individuals who reflect the diversity of our community, as well as the values
                                and vision of our administration.”
                            </p>
                            <footer className="blockquote-footer" style={{ marginTop: 0 }}>
                                <cite title="Source Title">Dr. Sam Page</cite>
                            </footer>
                        </blockquote>
                    </Col>
                </Row>
                
                <div className='row mt-1'>
                    <div className="col-lg-4 col-12">
                        <Card tag="a" onClick={this.exploreBoards} style={{ cursor: "pointer" }}>
                            <CardImg src={ExploreBoards} alt="Explore Boards and Commissions"/>
                            <CardImgOverlay className="h-100 card-image">
                                <CardBody tag="h3" style={{ color: "white" }}>Explore Boards and Commissions</CardBody>                                                                
                                <div className="h-40 d-flex flex-column justify-content-end align-items-end">
                                    <CardText tag="h4" style={{ color: "white", backgroundColor: "grey", padding: "10px", borderRadius: "5px" }}>Click to Explore</CardText>
                                </div>
                            </CardImgOverlay>
                        </Card>
                    </div>
                    
                    <div className="col-lg-4 col-12">
                        <Card tag="a" onClick={this.applyBoards} style={{ cursor: "pointer" }}>
                            <CardImg src={Applications} alt="Apply"/>
                            <CardImgOverlay className="h-100 card-image">
                                <CardBody tag="h3" style={{ color: "white" }}>Apply for a Board or Commission</CardBody>
                                <div className="h-40 d-flex flex-column justify-content-end align-items-end">
                                    <CardText tag="h4" style={{ color: "white", backgroundColor: "grey", padding: "10px", borderRadius: "5px" }}>Click to Get Started</CardText>
                                </div>
                            </CardImgOverlay>
                        </Card>
                    </div>
                    <div className="col-lg-4 col-12">
                        <Card tag="a" onClick={this.watchMeetings} style={{ cursor: "pointer" }}>
                            <CardImg src={Watch} alt="Watch past meetings"/>
                            <CardImgOverlay className="h-100 card-image">
                                <CardBody tag="h3" style={{ color: "white" }}>Watch a Past Meeting</CardBody>
                                <div className="h-40 d-flex flex-column justify-content-end align-items-end">
                                    <CardText tag="h4" style={{ color: "white", backgroundColor: "grey", padding: "10px", borderRadius: "5px" }}>Click to Watch</CardText>
                                </div>
                            </CardImgOverlay>
                        </Card>
                    </div>
                </div>               
            </div>
        );
  }
}
